let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("eNmuD"), load("h2MrD"), load("bYT2S"), load("cM9em"), load("fr9NE"), load("4mQEr")]).then(() => parcelRequire('egnL1'));